import I18n from '../../../config/i18n';
import AnneSophie from '../assets/Anne-Sophie.jpg';
import AnneSophie2x from '../assets/Anne-Sophie@2x.jpg';
import Daniel from '../assets/Daniel.jpg';
import Daniel2x from '../assets/Daniel@2x.jpg';
import Dusty from '../assets/Dusty.jpg';
import Dusty2x from '../assets/Dusty@2x.jpg';
import Florence from '../assets/Florence.jpg';
import Florence2x from '../assets/Florence@2x.jpg';
import Jennifer from '../assets/Jennifer.jpg';
import Jennifer2x from '../assets/Jennifer@2x.jpg';
import Jeroen from '../assets/Jeroen.jpg';
import Jeroen2x from '../assets/Jeroen@2x.jpg';
import Julie from '../assets/Julie.jpg';
import Julie2x from '../assets/Julie@2x.jpg';
import Katja from '../assets/Katja.jpg';
import Katja2x from '../assets/Katja@2x.jpg';
import Kino from '../assets/Kino.jpg';
import Kino2x from '../assets/Kino@2x.jpg';
import Sabrina from '../assets/Sabrina.jpg';
import Sabrina2x from '../assets/Sabrina@2x.jpg';
import Sarah from '../assets/Sarah.jpg';
import Sarah2 from '../assets/Sarah2.jpg';
import Sarah22x from '../assets/Sarah2@2x.jpg';
import Sarah2x from '../assets/Sarah@2x.jpg';
import Thomas from '../assets/Thomas.jpg';
import Thomas2x from '../assets/Thomas@2x.jpg';
import Vanessa from '../assets/Vanessa.jpg';
import Vanessa2x from '../assets/Vanessa@2x.jpg';
import Ogone from '../assets/ogone.jpg';
import ActionFun from '../assets/ActionFun.jpg';

const aboutData = {
  benefits: () => [
    {
      headline: I18n.t('your_benefits.h2'),
      icon: 'money',
      content: I18n.t('your_benefits.p2'),
      list: [
        {
          content: I18n.t('your_benefits.list_item2_1'),
        },
        {
          content: I18n.t('your_benefits.list_item2_2'),
        },
        {
          content: I18n.t('your_benefits.list_item2_3'),
        },
      ],
    },
    {
      headline: I18n.t('your_benefits.h3'),
      icon: 'shield',
      content: I18n.t('your_benefits.p3'),
      list: [
        {
          content: I18n.t('your_benefits.list_item3_1'),
        },
        {
          content: I18n.t('your_benefits.list_item3_2'),
        },
      ],
    },
    {
      headline: I18n.t('your_benefits.h4'),
      icon: 'phone',
      content: I18n.t('your_benefits.p4'),
      list: [
        {
          content: I18n.t('your_benefits.list_item4_1'),
        },
        {
          content: I18n.t('your_benefits.list_item4_2'),
        },
        {
          content: I18n.t('your_benefits.list_item4_3'),
        },
      ],
    },
  ],
  team: () => [
    {
      name: 'Dusty',
      position: I18n.t('your_benefits.positions.ceo'),
      image: Dusty,
      image2x: Dusty2x,
    },
    {
      name: 'Julie',
      position: I18n.t('your_benefits.positions.teamleader'),
      image: Julie,
      image2x: Julie2x,
    },
    {
      name: 'Katja',
      position: I18n.t('your_benefits.positions.business_development'),
      image: Katja,
      image2x: Katja2x,
    },
    {
      name: 'Anne-Sophie',
      position: I18n.t('your_benefits.positions.service_marketing'),
      image: AnneSophie,
      image2x: AnneSophie2x,
    },
    {
      name: 'Daniel',
      position: I18n.t('your_benefits.positions.business_development_spain'),
      image: Daniel,
      image2x: Daniel2x,
    },
    {
      name: 'Florence',
      position: I18n.t('your_benefits.positions.business_development'),
      image: Florence,
      image2x: Florence2x,
    },
    {
      name: 'Jennifer',
      position: I18n.t('your_benefits.positions.business_development'),
      image: Jennifer,
      image2x: Jennifer2x,
    },
    {
      name: 'Jeroen',
      position: I18n.t('your_benefits.positions.business_development'),
      image: Jeroen,
      image2x: Jeroen2x,
    },
    {
      name: 'Kino',
      position: I18n.t('your_benefits.positions.service_marketing'),
      image: Kino,
      image2x: Kino2x,
    },
    {
      name: 'Sabrina',
      position: I18n.t('your_benefits.positions.business_development'),
      image: Sabrina,
      image2x: Sabrina2x,
    },
    {
      name: 'Sarah',
      position: I18n.t('your_benefits.positions.service'),
      image: Sarah2,
      image2x: Sarah22x,
    },
    {
      name: 'Sarah',
      position: I18n.t('your_benefits.positions.accounting'),
      image: Sarah,
      image2x: Sarah2x,
    },
    {
      name: 'Vanessa',
      position: I18n.t('your_benefits.positions.service_marketing'),
      image: Vanessa,
      image2x: Vanessa2x,
    },
    {
      name: 'Thomas',
      position: I18n.t('your_benefits.positions.photography'),
      image: Thomas,
      image2x: Thomas2x,
    },
  ],
  partners: {
    actionFun: ActionFun,
    ogone: Ogone,
  },
  contactLanguages: ['de', 'be', 'lu'],
};

export default aboutData;
